Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetFootprintAccuracy = void 0;
var GetFootprintAccuracy = exports.GetFootprintAccuracy = function GetFootprintAccuracy(sections) {
  if (!sections || sections.length === 0) return undefined;
  var total = sections.length * 100;
  var percent = Math.floor(sections.reduce(function (a, v) {
    return a + (v == null ? void 0 : v.complete_percentage) || 0;
  }, 0) / total * 100);
  if (percent < 100) {
    return percent;
  }
  return undefined;
};